import React from 'react'

import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

import InfluencerIdentityRowLabelTooltip from '@components/InfluencerIdentity/Row/LabelTooltip'
import InfluencerIdentityRowValueAndLabel from '@components/InfluencerIdentity/Row/ValueAndLabel'
import { useInfluencerIdentityId } from '@context/InfluencerIdentityId'
import { useCampaignIdFromRoute } from '@hooks/useCampaignIdFromRoute'
import { IApplicationState } from '@store'
import { selectInfluencerIdentityFollowerCount } from '@store/influencerIdentities'
import { abbreviateNumber } from '@utils'

const InfluencerIdentityRowPerformanceFollowerCount: React.FC = () => {
  const campaignId = useCampaignIdFromRoute()
  const { contextInfluencerIdentityId } = useInfluencerIdentityId()
  const followerCount = useSelector((state: IApplicationState) =>
    selectInfluencerIdentityFollowerCount(state, campaignId, contextInfluencerIdentityId),
  )

  return (
    <InfluencerIdentityRowValueAndLabel
      value={abbreviateNumber(followerCount)}
      label={
        <InfluencerIdentityRowLabelTooltip
          title={<FormattedMessage id="submission.performance.followers" />}
          body={<FormattedMessage id="submission.performance.followers.body" />}
        >
          <FormattedMessage id="submission.performance.followers" />
        </InfluencerIdentityRowLabelTooltip>
      }
      width={5.25}
    />
  )
}

export { InfluencerIdentityRowPerformanceFollowerCount }

export default InfluencerIdentityRowPerformanceFollowerCount
